const steps = [
  {
    number: "01",
    title: "Assessment",
    description: "We analyze your current systems and identify transformation opportunities."
  },
  {
    number: "02",
    title: "Strategy",
    description: "Develop a tailored roadmap aligned with your business objectives."
  },
  {
    number: "03",
    title: "Implementation",
    description: "Execute the transformation with our expert team and proven methodologies."
  },
  {
    number: "04",
    title: "Optimization",
    description: "Continuously improve and adapt based on performance metrics."
  }
];

export const Process = () => {
  return (
    <section id="process" className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            How We Transform Your Business
          </h2>
          <p className="text-xl text-gray-600">
            A proven process that delivers results
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative"
            >
              <div className="bg-white p-6 rounded-xl border border-gray-200 hover:border-primary transition-colors">
                <div className="text-4xl font-bold text-primary/20 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gray-200" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};